exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-control[data-v-d5c73f84]{z-index:0}", ""]);

// exports
